(() => {
  'use strict';
  let dialog, heading, photo, close, opener, pending = false;
  const makeDialog = () => {
    if (dialog) return;
    dialog = document.createElement('dialog');
    dialog.className = 'ura-fabric-dialog';
    dialog.setAttribute('aria-labelledby', 'UraFabricOriginalTitle');
    const head = document.createElement('div');
    head.className = 'ura-fabric-dialog__head';
    heading = document.createElement('h2'); heading.id = 'UraFabricOriginalTitle';
    close = document.createElement('button'); close.type = 'button'; close.textContent = '×';
    photo = document.createElement('img'); photo.decoding = 'async';
    head.append(heading, close); dialog.append(head, photo); document.body.append(dialog);
    close.addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => {
      const r = dialog.getBoundingClientRect();
      if (event.target === dialog && (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom)) dialog.close();
    });
    dialog.addEventListener('close', () => opener?.focus({preventScroll:true}));
  };
  const initialize = () => {
    pending = false;
    document.querySelectorAll('[data-card-original-tag]').forEach(tag => {
      const card = tag.closest('[data-ura-preview-card],.ura2-product-card');
      if (!card || card.hasAttribute('data-ura-fabric-card')) return;
      const button = document.createElement('button');
      button.type = 'button'; button.className = 'ura-fabric-peek';
      button.setAttribute('aria-haspopup', 'dialog');
      button.setAttribute('aria-label', tag.dataset.cardTechControlLabel);
      const icon = document.createElementNS('http://www.w3.org/2000/svg','svg');
      icon.setAttribute('viewBox','0 0 24 24');icon.setAttribute('aria-hidden','true');
      const path = document.createElementNS('http://www.w3.org/2000/svg','path');
      path.setAttribute('d','M4 3h9l7 7-10 10-7-7V4z M7.5 7.5h.01');path.setAttribute('stroke-width','1.5');
      icon.append(path);
      const text = document.createElement('span');text.textContent = tag.dataset.cardTechName;
      button.append(icon,text);card.append(button);card.setAttribute('data-ura-fabric-card','');
      button.addEventListener('click', event => {
        event.preventDefault();event.stopPropagation();makeDialog();opener = button;
        heading.textContent = tag.dataset.cardTechName;photo.src = tag.dataset.cardOriginalTag;
        photo.alt = tag.dataset.cardTechControlLabel;close.setAttribute('aria-label',tag.dataset.cardTagClose);
        dialog.showModal();close.focus({preventScroll:true});
      });
    });
  };
  const start = () => {
    initialize();
    const main = document.getElementById('MainContent');
    if (main) new MutationObserver(records => {
      if (!pending && records.some(record => record.addedNodes.length)) {
        pending = true;requestAnimationFrame(initialize);
      }
    }).observe(main,{childList:true,subtree:true});
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',start,{once:true});
  else start();
  document.addEventListener('shopify:section:load',initialize);
})();
